// Installed app or browser (M53, docs/installed-app.md).

import type { AppMode } from '@twinden/shared';
import { isInstalledApp } from './pwa';

/** How this page was opened: the installed web app or a browser tab (D186). */
export function currentAppMode(): AppMode {
  return isInstalledApp() ? 'installed' : 'browser';
}

// "Not now" on the install card hides it this long on this device (D184).
export const INSTALL_NUDGE_SNOOZE_MS = 14 * 24 * 3600 * 1000;
const SNOOZE_KEY = 'twinden:installNudgeSnoozedAt';

export function installNudgeSnoozedAt(): number | null {
  try {
    const value = Number(localStorage.getItem(SNOOZE_KEY));
    return value > 0 ? value : null;
  } catch {
    return null;
  }
}

export function snoozeInstallNudge(now = Date.now()) {
  try {
    localStorage.setItem(SNOOZE_KEY, String(now));
  } catch {
    // Private mode: the card goes for this visit only.
  }
}

/**
 * What the install card shows (D184): nothing in the installed app or while
 * snoozed; on a phone whose store link is set, Get the Twinden app, which
 * opens the store (D346); otherwise Install when the browser can prompt
 * (Android, desktop), else How, which opens the guide (iPhone, or no prompt
 * yet).
 */
export function installNudge(input: {
  installed: boolean;
  snoozedAt: number | null;
  promptAvailable: boolean;
  now: number;
  /** This phone's store link (phoneStoreUrl); null on a computer or unset. */
  storeUrl?: string | null;
}): 'store' | 'install' | 'how' | null {
  if (input.installed) return null;
  if (
    input.snoozedAt !== null &&
    input.now - input.snoozedAt < INSTALL_NUDGE_SNOOZE_MS
  ) {
    return null;
  }
  if (input.storeUrl) return 'store';
  return input.promptAvailable ? 'install' : 'how';
}
